import { FETCH_TAXONOMY_REQUEST, FETCH_TAXONOMY_SUCCESS, FETCH_TAXONOMY_FAILURE } from "./TaxonomyTypes";

const initialState = {
  loading: false,
  TaxonomyData: {}, 
  error: "",
};


const TaxonomyReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_TAXONOMY_REQUEST:
      return { ...state, loading: true };

    case FETCH_TAXONOMY_SUCCESS:
      return {
        ...state,
        loading: false,
        TaxonomyData: {
          ...state.TaxonomyData,
          [action.baseUrl]: action.payload,  // Store by baseUrl
        },
        error: "",
      };

    case  FETCH_TAXONOMY_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default TaxonomyReducer;

